export default __webpack_public_path__ + "static/balljam-b3c90c7c3152630cf25bd1454425eee8.svg";